export const ADMIN_LOGIN_REQUEST="ADMIN_LOGIN_REQUEST"
export const ADMIN_LOGIN_SUCCESS="ADMIN_LOGIN_SUCCESS"
export const ADMIN_LOGIN_FAIL="ADMIN_LOGIN_FAIL"

export const ADMIN_LOGOUT="ADMIN_LOGOUT"